import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VConsole from "vconsole";

import './vant/vant'

import {Base64} from "js-base64";
Vue.use(Base64)

// new VConsole()

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
